// Set an initial page number.
let globalPageNum = 1;
let globalFilterType = 'all';

if ( document.readyState === 'loading' ) {

	// The DOM has not yet been loaded.
	document.addEventListener( 'DOMContentLoaded', initLatestPostsComponent );

} else {

	// The DOM has already been loaded.
	initLatestPostsComponent();
}


/**
 * Update the global page number to maintain state
 *
 * @param {Int} num The page number to update
 */
function updatePageNum( num ) {
	globalPageNum = parseInt( num );
}

/**
 * Return the global page number
 *
 * @return {Int} globalPageNum
 */
function getPageNum() {
	return parseInt( globalPageNum );
}

/**
 * Update the global post type so it can be used when
 * navigation to another page. This maintins the
 * pagination query. If type is a blank string, the
 * filters are reset.
 *
 * @param {String} type the selected filter post type
 */
function setFilterType( type ) {
	globalFilterType = type;
}

/**
 * Return the global filter type
 *
 * @return {String} globalFilterType
 */
function getFilterType() {
	return globalFilterType;
}

/**
 * Fetch the dynamic content through the custom REST API endpoints.
 */
function initLatestPostsComponent() {

	const postsContainer = jQuery('.js-recent-posts');
	const filtersContainer = jQuery('.js-filters');
	const paginationContainer = jQuery( '.js-pagination' );
	const filterCats = {...filtersContainer.data('cats')};
	const filterTags = {...filtersContainer.data('tags')};
	const filterType = postsContainer.data('post_type');
	const mobileFilterSelect = jQuery( '.js-select-filter' );

	// If post type set activate filter in order for the pagination to work properly.
	if ( filterType ) {
		setFilterType( filterType );
	}

	let mobileFilterSelectText = jQuery( '.js-select-filter > option:first-child' );

	const wp = window.wp;
	const latestPostsTemplate = wp.template( "latest-posts" );
	const paginationTemplate  = wp.template( "latest-posts-pagination" );

	// INIT.
	initDesktopFilters();
	initMobileFilters();
	initPaginationHandler();

	function initDesktopFilters() {

		if ( filtersContainer === undefined || filtersContainer.length === 0 ) {
			return false;
		}

		let filterButton = jQuery( '.js-button-filter' );

		// Add click handlers on to the pagination.
		filterButton.on( 'click', function(e) {

			let selectedFilter = jQuery(this).data('type');
			if( selectedFilter !== undefined ) {
				setFilterType( selectedFilter );
				updatePageNum( 1 );
				fetchLatestPosts();
			}

			e.preventDefault();
		} );
	}

	function initMobileFilters() {

		if ( mobileFilterSelect === undefined || mobileFilterSelect.length === 0 ) {
			return false;
		}

		mobileFilterSelect.on( 'change', function() {

			let filterType = jQuery(this).val();
			if( filterType !== undefined ) {

				if( filterType !== 'all' ) {
					mobileFilterSelectText.text('Show all...');
				} else {
					mobileFilterSelectText.text('Select...');
				}

				setFilterType( filterType );
				updatePageNum( 1 );
				fetchLatestPosts();
			}

		} );

	}

	// Function to set up the pagination.
	function initPaginationHandler() {

		// Return early if the pagination is not in the DOM.
		if ( paginationContainer === undefined || paginationContainer.length === 0 ) {
			return false;
		}

		// Add a class for mobile to position the pagination for small screen devices.
		paginationContainer.removeClass('negative-offset negative-offset--sm');
		if( getPageNum() === 2 || getPageNum() === 3 || getPageNum() === 9 ) {
			paginationContainer.addClass('negative-offset--sm');
		} else if( getPageNum() > 3 && getPageNum() < 9 ) {
			paginationContainer.addClass('negative-offset');
		}

		// Set up the event handlers on the pagination.
		jQuery( '.js-pagination li a.page-numbers' ).on( 'click', function(e) {
			e.preventDefault();
			let $this = jQuery(this);

			if ( $this.hasClass( 'prev' ) ) {
				updatePageNum( getPageNum() - 1 );
			} else if ( $this.hasClass( 'next' ) ) {
				updatePageNum( getPageNum() + 1 );
			} else {
				updatePageNum( $this.text() );
			}

			if ( getPageNum() >= 1 ) {
				fetchLatestPosts();
			}
		} );
	}

	/**
	 * Use wp.template to output the HTML page numbers inside the pagination container.
	 *
	 * @param {Object} paginationObj The data containing pages from the AJAX response.
	 */
	function renderPagination( paginationObj ) {

		// Pages is an array of objects.
		for( let i = 0; i < paginationObj.pages.length; i++ ) {
			paginationContainer.append(
				paginationTemplate( paginationObj.pages[i] )
			);
		}
	}

	/**
	 * Perform the actual AJAX call to the custom REST API endpoint.
	 *
	 * @file Latest_Posts\Component
	 *
	 * @param {int} pageNum page number needed for the API endpoint.
	 */
	function fetchLatestPosts() {

		const selectedClass = 'c-button--current';
		const filterButton = jQuery('.js-button-filter');

		jQuery.ajax({
			url: bitc_postdata.endpoint,
			dataType: 'json',
			data: {
				page: getPageNum(),
				type: getFilterType(),
				cats: filterCats,
				tags: filterTags
			},
			success: function( data ) {

				// Update the current filter class.
				filterButton.removeClass(selectedClass);
				jQuery(`.js-button-filter[data-type="${getFilterType()}"]`).addClass(selectedClass);

				// Clear the posts container.
				jQuery(postsContainer).empty();

				// Pages is an array of objects.
				for( let p = 0; p < data.posts.length; p++ ) {
					postsContainer.append(
						latestPostsTemplate( data.posts[p] )
					);
				}

				if ( paginationContainer !== undefined || paginationContainer.length !== 0 ) {
					jQuery( paginationContainer ).empty();
					if( data.pagination.pages ) {
						// Render the pagination.
						renderPagination( data.pagination );

						// Add the pagination handler.
						initPaginationHandler();

					}
				}
			},
			error: function( data ) {
			},

		});
	}

}
